<script setup lang="ts">
  import {computed, ref} from 'vue';
  import CpIconStandard from '~/components/cp/CpIcon/CpIconStandard/CpIconStandard.vue';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import useCpBem from '~/composables/useCpBem';
  import {toCssVariable as toCss, useColors} from '~/composables/useCpType';

  const props = withDefaults(defineProps<{
      href?: string,
      to?: any,
      color?: 'primary'|'critical',
      withIcon?: boolean,
      disabled?: boolean,
      fullWidth?: boolean,
      newWindow?: boolean
  }>(), {
      color: 'primary',
      withIcon: true,
      disabled: false,
      fullWidth: false,
  });
  const toCssVariable = toCss;
  const colorDecoration = computed(() =>
      useColors(props.color, {disabled: props.disabled}));
  const color = computed(() =>
      props.disabled ?
          'neutral-light' :
          active.value ?
              colorDecoration.value.active :
              colorDecoration.value.background,
  );

  const {bm, e} = useCpBem('cp-link');
  const active = ref(false);
</script>

<template>
    <NuxtLink
        :class="bm({disabled: disabled, fullWidth: fullWidth})"
        :href="href"
        :target="newWindow ? '_blank' : ''"
        :to="to"
        :prefetch="false"
        @pointerdown="active = true"
        @pointerup="active = false"
    >
        <CpText
            :class="e('text-decoration')"
            variant="body-bold"
            as="span"
            :type="color"
        >
            <slot />
        </CpText>
        <CpIconStandard
            v-if="withIcon"
            style="text-decoration: none"
            icon="chevron_right"
            :type="color"
        />
    </NuxtLink>
</template>

<style lang="scss" scoped>
    .cp-link {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 8px;
        text-decoration: none;
        user-select: none;

        &--full-width {
          width: auto;
        }
        &--disabled {
          pointer-events: none;
        }
        &__text-decoration{
          text-decoration-color: v-bind("toCssVariable(colorDecoration.active)");
          text-decoration: underline;
        }
    }
</style>
